import { render, staticRenderFns } from "./GameSettingPannel.vue?vue&type=template&id=41ba1eb9&scoped=true"
import script from "./GameSettingPannel.vue?vue&type=script&lang=js"
export * from "./GameSettingPannel.vue?vue&type=script&lang=js"
import style0 from "./GameSettingPannel.vue?vue&type=style&index=0&id=41ba1eb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba1eb9",
  null
  
)

export default component.exports